import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HabitosAlimentares } from '../../models/HabitosAlimentares';
import axiosClient from '../../../shared/axios/axios-client';
import { ResultadoImportacao } from '../../dto/importacao/ImportacaoDTO';

export interface HistoricoImportacao {
  id?: number;

  nomePlanilha: string;
  nomeArquivo: string;
  hashArquivo?: string;
  versaoLayout?: string;
  sistemaOrigem?: string;
  ipOrigem?: string;

  totalLinhas?: number;
  linhasProcessadas?: number;
  linhasValidas?: number;
  linhasComErro?: number;

  status: string;

  tentativasProcessamento?: number;
  reprocessavel?: boolean;
  prioridade?: number;

  mensagemStatus?: string;

  dataCriacao?: Date;
  criadoPor?: number;
}

@Injectable({
  providedIn: 'root',
})
export class ImportacaoService {
  private apiUrl = environment.apiUrl;

  async importarPessoas(formData: FormData): Promise<any> {
    try {
      const empresaId = formData.get('empresaId');
      const enderecoId = formData.get('enderecoId');

      const response = await axiosClient.post(
        `${this.apiUrl}/importacao/planilha/${empresaId}/${enderecoId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      return response.data.data;
    } catch (error) {
      throw error;
    }
  }

  async exportarErros(idImportacao: number): Promise<Blob> {
    const response = await axiosClient.get(
      `${this.apiUrl}/importacao/planilha/${idImportacao}/erros`,
      { responseType: 'blob' },
    );
    return response.data;
  }

  async buscarHistorico(): Promise<HistoricoImportacao[]> {
    const response = await axiosClient.get(
      `${this.apiUrl}/importacao/historico`,
    );
    return response.data.data;
  }

  // Fazer download
  async baixarRelatorio(idImportacao: number): Promise<void> {
    const blob = await this.exportarErros(idImportacao);

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `erros_${idImportacao}.xlsx`;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
